export default Object.freeze({
  BASE_URL: "/api/v1/",
  USER_DATA_EXPIRE_TIME: '60',
  // RECAPTCHA_V2_SITE_KEY: '6LdUMscZAAAAAJxxO0wj0UUvHdCjBDk63aj0Vvfb',
  RECAPTCHA_INVISIBLE_SITE_KEY: '6LeC0LgqAAAAAD4KU1i60a0y9b1wcZd3ZmuMzoU7',
})
